module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_9005.92067f82.png";